<template>
    <div :column="column" :pushPage="pushPage" :procode="procode" :primaryKey="primaryKey">
        
        <span
            :title="pushText"
            v-if="pushText"
            class="limitTetx"
            :class="pushVal==false?'green':'red'"
            :underline="false">
                推送状态：{{pushText}}
        </span>
        <el-button 
            :loading="loadingVal"
            v-if="btnShow" 
            style="color:#FF8C00"
            type="text" 
            @click="refreshVal"
            icon="el-icon-refresh-left">
                同步推送状态
        </el-button>
        
    </div>
</template>

<script>
export default {
    props: {
        column: {
            type: Object,
            default: () => ({})
        },
        pushPage: {
            type: String,
            default: ''
        },
        procode: {
            type: String,
            default: ''
        },
        primaryKey:{
            type: String,
            default: ''
        },
    },
    data: () => ({
        pushText:'',
        pushVal:false,
        btnShow:false,
        loadingVal:false
    }),
    methods:{
        refreshVal(){
            this.loadingVal = true
            this.getRequest(1)
        },
        getRequest(val){
            var that = this
            $.get(`${that.getGetters('mngUrl')}/third/dock/`+that.pushPage+'/'+that.primaryKey +`/result.json`,{
                zbProCode:that.procode,
                t:Math.random(),
            }, data => {
                if(val==1){
                    setTimeout(() => {
                        that.loadingVal = false
                    }, 5000);
                    
                }
                if(data.t=='200'){
                    
                    if(data.msg.indexOf('未查询到推送记录')<0){
                        that.pushText = data.msg
                        if(data.msg.indexOf('已推送')>=0){
                            that.pushVal = false
                        }else{
                            that.pushVal = true
                        }
                        
                    }
                }else{
                    console.log(data.t,data.msg)
                    if(val==1){
                        setTimeout(() => {
                            that.loadingVal = false
                        }, 5000);
                        
                    }
                }
            })
        }
    },
    computed: {
        
    },
    mounted() {
        var that = this
        if(that.column.jyzxcode!='J13053001'){
            if(that.pushPage=='zbwj'){
                // 招标文件
                if(that.column.shbj=='1'&&that.column.by3=='1'&&that.column.xtts!='1'){
                    that.getRequest()
                    that.btnShow = true
                }
            }else if(that.pushPage=='ycgg'){
                // 招标异常终止
                if(that.column.shbj=='6'&&that.column.by5!='1'){
                    that.getRequest()
                    that.btnShow = true
                }
            }else{
                if(that.column.processflag==='1'
                    &&that.column.dockflag==='1'
                    &&that.column.xtts!=='1'
                    &&(that.column.pushstyle==='1'||that.column.pushstyle==='2'))
                {
                    that.getRequest()
                    that.btnShow = true
                }
            }
        }
        
        
    }
}
</script>

<style scoped lang="scss">
    .red{ color: #f56c6c; }
    .green{ color: #5daf34; }
</style>
